module.exports = __webpack_public_path__ + "media/images/icon__delete--rb-orange-a608de0c9e3c3a702d18292a9d9646e3.png";